export default {
  state: {
    isAct: false, // 是否为活动商品
    scene: '',
    goods: {},
    groupList: [],
    uriQuery: {},
    payStatus: 'select',
  },
  mutations: {
    updateScene(state, scene) {
      state.scene = scene;
    },
    updateGoods(state, goods) {
      state.goods = goods;
    },
    updateGroupList(state, groupList) {
      state.groupList = groupList;
    },
    updateUriQuery(state, uriQuery) {
      state.uriQuery = uriQuery;
      const {
        outActId = '',
        outActSystem = '',
        outActDetailId = '' } = uriQuery;
      if (outActId && outActSystem && outActDetailId) {
        state.isAct = true;
      } else {
        state.isAct = false;
      }
    },
    updatePayStatus(state, payStatus) {
      state.payStatus = payStatus;
    },
    updateYz(state, yz) {
      state.balanceAmt = yz;
    },
  },
};
